<template>
  <pt-detection-corpus-update class="pt-detection-corpus-update__withData"></pt-detection-corpus-update>
</template>

<script>
import PtDetectionCorpusUpdate from './index'
export default {
  name: 'pt-detection-corpus-update__withData',
  components: {
    'pt-detection-corpus-update': PtDetectionCorpusUpdate
  }
}
</script>
